<template>
    <div style="height: 100%;color: #334681;">
        <div class="search-box">
            <div class="tab-key-box">
                <div class="tab-key-item" @click="handleClick(item)" v-for="(item, index) in tabOptions" :key="index"
                    :class="{ 'tab-active': currentTab == item.value }">{{ item.label }}</div>
            </div>
            <div class="input-box" v-if="currentTab == 'studyRecord'">
                <div @click="search">院校筛选</div>
                <el-select class="el-select" @change="search" v-model="pages.college" placeholder="请选择">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
                <div @click="search" style="margin-right: 1rem;">搜索</div>
                <el-input class="el-input" v-model="pages.keywords" @keydown.enter.native="search" clearable
                    @clear="search" style="width: 20rem;" placeholder="请输入关键字">
                    <template slot="prefix">
                        <div class="search-ipt-box">
                            <img style="cursor: pointer;width: 16px;height: auto;"
                                src="../../../assets/image/magSys/search.png" @click="search" alt="">
                        </div>
                    </template>
                </el-input>
            </div>
        </div>
        <div class="content-box">
            <div class="banner-box">
                <p class="course-name">{{ courseInfo.courseName }}</p>
                <div class="hour-box">{{ courseInfo.courseStatus }}</div>
                <div class="label-box">
                    <div v-for="(item, index) in labelList" :key="index" :class="{ active: currentId == item.value }"
                        @click="changeLabel(item)" class="hour-item">
                        {{ item.label }}
                    </div>
                </div>
            </div>
            <div class="table-box">
                <Table :totalSize="pages.total" :pagination="true" :serialNumber="true" :operationWidth="350"
                    @changeCurrentPage="changeCurrentPage" @changePageSize="changePageSize" :currentPage="pages.current"
                    :pageSize="pages.size" navHeight=40 ref="table" :tableData="tableData" :tableKey="tableKey">
                    <template slot="finishingRate" slot-scope="data">
                        <span class="rate-text" @click="viewDetail(data.data.row)">{{
                            !data.data.row.teachingUnitCount ? '' : parseFloat(((data.data.row.completenessTeachingUnitCount || 0) / (data.data.row.teachingUnitCount || 0) *100).toFixed(2))+'%'
                            }}</span>
                    </template>
                    <template slot="userName" slot-scope="data">
                        <p v-if="data.data.row.userName">{{ tenantId == data.data.row.tenantId ? data.data.row.userName : (data.data.row.userName[0] + '**') }}
                        </p>
                    </template>
                    <template slot="className" slot-scope="data">
                        <p v-if="data.data.row.className">{{ tenantId == data.data.row.tenantId ? data.data.row.className : (data.data.row.className ? (data.data.row.className[0] + '**') : '') }}
                        </p>
                    </template>
                </Table>
            </div>
        </div>
        <study-detail ref="study_detail" :courseInfo="courseInfo" :openCourseId="currentId"></study-detail>
    </div>
</template>

<script>
import { PageQueryCourseStudyRecord, PageQueryCourseUseRecord, QueryCourseOpenPeriods, QueryCourseStudyTenantList } from '@/api/course';
import StudyDetail from './StudyDetail.vue';
export default {
  components: { StudyDetail },
    props: ['courseInfo'],
    data() {
        return {
            tabOptions: [
                {
                    label: '学习记录',
                    value: 'studyRecord'
                },
                {
                    label: '使用记录',
                    value: 'useRecord'
                },
            ],
            labelList: [],
            currentId: '',
            pages: {
                current: 1,
                size: 10,
                total: 0,
                keywords: '',
                /**院校过滤 */
                college: ''
            },
            tableKey1: [
                {
                    name: '姓名',
                    value: 'userName',
                    slot: 'userName'
                },
                {
                    name: '所属院校',
                    value: 'tenantName',
                },
                {
                    name: '班级',
                    value: 'className',
                    slot: 'className'
                },
                {
                    name: '学习时长',
                    value: 'studyTime'
                },
                {
                    name: '完成度',
                    value: 'finishingRate',
                    slot: 'finishingRate'
                },
                {
                    name: '最后上线时间',
                    value: 'finalStudyTime'
                },
            ],
            tableKey2: [
                {
                    name: '使用次数',
                    value: 'useCount'
                },
                {
                    name: '使用院校',
                    value: 'tenantName'
                },
                {
                    name: '使用时长',
                    value: 'useTime'
                },
                {
                    name: '最后上线时间',
                    value: 'finalStudyTime'
                },
            ],
            softwareCode: '',
            tableKey: [],
            /**列表数据 */
            tableData: [],
            /**院校可选项 */
            options: [],
            currentTab: 'studyRecord'
        }
    },
    computed: {
        tenantId() {
            return this.$store.state.user.userInfo.tenantId;
        }
    },
    methods: {
        commonQuery() {
            if (this.currentTab == 'studyRecord') {
                this.pageQueryCourseStudyRecord();
            } else {
                this.pageQueryCourseUseRecord();
            }
        },
        /**切换tab */
        handleClick(item) {
            this.currentTab = item.value;
            this.initData();
            this.commonQuery();
        },
        changeLabel(item) {
            this.currentId = item.value;
            this.search();
        },
        /**获取租户 */
        queryCourseStudyTenantList() {
            QueryCourseStudyTenantList(this.courseInfo.id).then(res => {
                if (res.code == 200) {
                    this.options = res.data.map(item => {
                        return {
                            label: item.tenantName,
                            value: item.tenantId
                        }
                    })
                    this.options = [{ label: '全部', value: '' }, ...this.options];
                }
            })
        },
        /**分页查询课程学习记录 */
        pageQueryCourseStudyRecord() {
            let params = {
                "courseId": this.courseInfo.id,
                "current": this.pages.current,
                "openCourseId": this.currentId,
                "tenantId": this.pages.college,
                "userName": this.pages.keywords,
                "size": this.pages.size
            };
            PageQueryCourseStudyRecord(params).then(res => {
                if (res.code == 200) {
                    this.tableData = res.data.records;
                    this.pages.total = res.data.total;
                }
            })
        },
        /**查询期数 */
        queryCourseOpenPeriods() {
            QueryCourseOpenPeriods(this.courseInfo.id).then(res => {
                if (res.code == 200) {
                    this.labelList = res.data.map(item => {
                        return {
                            label: item.periods,
                            value: item.openCourseId
                        }
                    })
                    if (this.labelList.length > 0) {
                        this.currentId = this.labelList[this.labelList.length-1].value;
                        this.pageQueryCourseStudyRecord();
                    } else {
                        this.tableData = [];
                    }
                }
            })
        },
        /**分页查询课程使用记录 */
        pageQueryCourseUseRecord() {
            let params = {
                "courseId": this.courseInfo.id,
                "current": this.pages.current,
                "openCourseId": this.currentId,
                "size": this.pages.size
            }
            PageQueryCourseUseRecord(params).then(res => {
                if (res.code == 200) {
                    this.tableData = res.data.records;
                    this.pages.total = res.data.total;
                }
            })
        },
        /**切换tab初始化数据 */
        initData() {
            this.pages.current = 1;
            this.pages.keywords = '';
            this.pages.college = '';
            var obj = {
                studyRecord: this.tableKey1,
                useRecord: this.tableKey2
            }
            this.tableKey = obj[this.currentTab];
        },
        search() {
            this.pages.current = 1;
            this.commonQuery();
        },
        changeCurrentPage(e) {
            this.pages.current = e;
            this.commonQuery();
        },
        changePageSize(e) {
            this.pages.size = e;
            this.pages.current = 1;
            this.commonQuery();
        },
        viewDetail(data){
            let dialog=this.$refs.study_detail;
            if(dialog){
                dialog.dialogVisible=true;
                dialog.detail=data;
                dialog.viewTrainList();
            }
        }
    },
    mounted() {
        this.initData();
        this.queryCourseStudyTenantList();
        this.queryCourseOpenPeriods();
    },
    destroyed() {
        this.$store.commit('course/changeOperation', '');
        this.$store.commit('backend/changeOptlabel', '');
    }
}
</script>

<style lang="less" scoped>
.tab-key-box {
    display: flex;
    background: #ffffff;
    border: 1px solid #e8ecef;
    border-radius: 1rem;
    box-shadow: 0px 0px 2.9rem 0px rgba(180, 190, 220, 0.30);
    width: 14rem;
    height: 4rem;

    .tab-key-item {
        width: 50%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--blue);
        cursor: pointer;
    }

    &> :nth-child(1) {
        border-top-left-radius: 1rem;
        border-bottom-left-radius: 1rem;
        transition: all 0.3s;
    }

    &> :nth-child(2) {
        border-top-right-radius: 1rem;
        border-bottom-right-radius: 1rem;
        transition: all 0.3s;
    }
}

.tab-active {
    color: #ffffff !important;
    background-color: var(--blue) !important;
}

.search-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.input-box {
    display: flex;
    align-items: center;
    color: #334681;

    &> :nth-child(1) {
        margin-right: 1rem;
    }

    .search-ipt-box {
        display: flex;
        align-items: center;
        width: 3.5rem;
        justify-content: center;
        height: 100%;
    }
}

.el-input {
    /deep/.el-input__inner {
        height: 4rem;
        border-radius: 1rem;
        padding-left: 3.5rem;
    }
}

.el-select {
    margin-right: 3rem;

    /deep/.el-input__inner {
        height: 4rem;
        border-radius: 1rem;
    }
}

.content-box {
    height: calc(100% - 6rem);
    margin-top: 2.4rem;

    /deep/.el-table--border th {
        background-color: #ffffff !important;
    }
}

.blue-color {
    color: var(--blue);
    cursor: pointer;
}

.banner-box {
    height: 8rem;
    background: #ffffff;
    border: 1px solid #edf3f9;
    border-radius: 10px;
    padding: 0 3rem;
    display: flex;
    align-items: center;
    margin: 1.5rem 0;

    .course-name {
        font-size: 1.8rem;
        font-weight: 700;
    }

    .hour-box {
        width: 5.4rem;
        height: 2.2rem;
        background: #387dff;
        border-radius: 2px 1rem 2px 1rem;
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 1rem;
    }
}

.label-box {
    display: flex;
    width: calc(100% - 17rem);
    overflow: auto;

    .hour-item {
        padding: 0.6rem 1rem;
        background: #EDF3F9;
        border: 1px solid #387dff;
        border-radius: 6px;
        margin-left: 2rem;
        color: #387DFF;
        cursor: pointer;
    }

    &> :nth-child(1) {
        margin-left: 5rem;
    }
}

.active {
    background-color: var(--blue) !important;
    color: #ffffff !important;
}

.table-box {
    height: calc(100% - 9rem);
}
.icon-xiangqing{
    color: var(--blue);
    font-size: 1.8rem;
    cursor: pointer;
}
.rate-text{
    color: var(--blue);
    cursor: pointer;
}
</style>